/* istanbul ignore file */
import { useEffect } from 'react';

import {
  useAcceptsReservations,
  useAcceptsWaitlist
} from 'reservations/account/providers/ConfigProvider';
import { REDIRECT_NOT_ACCEPTING_BOOKING } from 'reservations/base/constants/redirects';
import { useCustomRouter } from 'reservations/base/providers/RouterProvider';

export function useRouteIfAppDisabled() {
  const isAcceptingReservations = useAcceptsReservations();
  const isAcceptingWaitlist = useAcceptsWaitlist();
  const { handleNavigation } = useCustomRouter();

  useEffect(() => {
    if (!isAcceptingReservations && !isAcceptingWaitlist) {
      handleNavigation(REDIRECT_NOT_ACCEPTING_BOOKING);
    }
  }, [isAcceptingReservations, isAcceptingWaitlist, handleNavigation]);
}
